<template>
  <div class="product-detail-container">
    <h4 class="page-title">产品详情编辑</h4>
    
    <!-- 产品基本信息 -->
    <div class="section">
      <h6 class="section-title">产品基本信息【这些产品字段直接读取OMS系统，不可编辑。如需修改请到OMS系统操作】</h6>
      <div class="info-row">
        <div class="info-label">产品SKU：</div>
        <div class="info-value uneditable">{{ product.sku || '-' }}</div>
        <div class="info-label">当前归属人：</div>
        <div class="info-value uneditable">{{ product.salesman || '-' }}</div>
      </div>
      <div class="info-row">
        <div class="info-label">产品中文名：</div>
        <div class="info-value uneditable">{{ product.skuName || '-' }}</div>
        <div class="info-label">产品英文名：</div>
        <div class="info-value uneditable">{{ product.skuNameEn || '-' }}</div>
      </div>
      <div class="info-row">
        <div class="info-label">产品分类：</div>
        <div class="info-value uneditable">{{ product.categorize || '-' }}</div>
        <div class="info-label">是否公品：</div>
        <div class="info-value uneditable">{{ product.publicStatus || '-' }}</div>
        <div class="info-label">总签收率：</div>
        <div class="info-value uneditable">{{ product.signRate || '-' }}</div>
      </div>
    </div>
    
    <!-- 产品质量信息 -->
    <div class="section">
      <h6 class="section-title">产品质量信息 【必填】</h6>

      <div class="form-group">
        <label class="form-label">产品质量等级：</label>
        <div class="radio-group">
          <el-radio-group v-model="formData.qualityLevel">
            <el-radio :label="1">高质量</el-radio>
            <el-radio :label="2">普通</el-radio>
            <el-radio :label="3">售后多</el-radio>
          </el-radio-group>
        </div>
      </div>
      
      <div class="form-group">
        <label class="form-label">是否对板：</label>
        <div class="radio-group">
          <el-radio-group v-model="formData.matchLevel">
            <el-radio :label="1">对板</el-radio>
            <el-radio :label="2">货不对板</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    
    <!-- 产品素材 -->
    <div class="section">
      <h6 class="section-title">产品素材 【上传第一次浏览的素材，用于Facebook平台投放。后续也可以更新版出单量最多的素材】</h6>

      <div class="form-group">
        <label class="form-label">Facebook投放文章：</label>
        <el-input
          type="textarea"
          v-model="formData.merits"
          :rows="5"
          placeholder="请输入Facebook投放文章内容"
          maxlength="1000"
          show-word-limit
        ></el-input>
      </div>

      <!-- 上传按钮行 -->
      <div class="form-group">
        <div class="upload-row">
          <!-- 图片上传按钮 -->
          <div class="upload-col">
            <label class="upload-label">上传图片：</label>
            <el-upload
              class="upload-button"
              action="/data-serv/common/upload-private"
              :headers="uploadHeaders"
              :data="{ sku: sku }"
              :show-file-list="false"
              :before-upload="beforeImageUpload"
              :on-success="handleImageSuccess"
              :on-error="handleImageError"
              :on-progress="handleImageProgress"
              accept="image/*"
            >
              <el-button size="small" type="primary" plain>
                <i class="el-icon-upload"></i> 选择图片（1M内）
              </el-button>
            </el-upload>
          </div>

          <!-- 视频上传按钮 -->
          <div class="upload-col">
            <label class="upload-label">上传视频：</label>
            <el-upload
              class="upload-button"
              action="/data-serv/common/upload-private"
              :headers="uploadHeaders"
              :data="{ sku: sku }"
              :show-file-list="false"
              :before-upload="beforeVideoUpload"
              :on-success="handleVideoSuccess"
              :on-error="handleVideoError"
              :on-progress="handleVideoProgress"
              accept="video/*"
            >
              <el-button size="small" type="primary" plain>
                <i class="el-icon-upload"></i> 选择视频（10M内）
              </el-button>
            </el-upload>
          </div>
        </div>

        <!-- 上传进度条 -->
        <div class="progress-row">
          <div class="progress-col">
            <div v-if="imageUploading" class="progress-container">
              <el-progress 
                :percentage="imageProgress" 
                :stroke-width="6"
                :color="imageProgressColor"
              ></el-progress>
            </div>
          </div>
          <div class="progress-col">
            <div v-if="videoUploading" class="progress-container">
              <el-progress 
                :percentage="videoProgress" 
                :stroke-width="6"
                :color="videoProgressColor"
              ></el-progress>
            </div>
          </div>
        </div>
      </div>

      <!-- 预览区域 - 图片和视频并排 -->
      <div class="preview-row">
        <!-- 图片预览 -->
        <div class="preview-col">
          <div class="preview-card">
            <h6 class="preview-title">图片预览</h6>
            <div class="preview-content">
              <img v-if="formData.imageUrl" :src="formData.imageUrl" class="preview-img" alt="产品图片">
              <div v-else class="no-preview">暂无图片</div>
            </div>
          </div>
        </div>

        <!-- 视频预览 -->
        <div class="preview-col">
          <div class="preview-card">
            <h6 class="preview-title">视频预览</h6>
            <div class="preview-content">
              <video v-if="formData.videoUrl" :src="formData.videoUrl" controls class="preview-video"></video>
              <div v-else class="no-preview">暂无视频</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="action-buttons">
      <el-button type="primary" @click="handleSave" :loading="saving" :disabled="saving">
        保存
      </el-button>
      <el-button @click="handleCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetail',
  data() {
    return {
      sku: '',
      product: {},
      formData: {
        qualityLevel: null,
        matchLevel: null,
        merits: '',
        imageUrl: '',
        videoUrl: ''
      },
      loading: false,
      saving: false,
      imageUploading: false,
      videoUploading: false,
      imageProgress: 0,
      videoProgress: 0,
      imageProgressColor: '#409EFF',
      videoProgressColor: '#409EFF',
      uploadHeaders: {
        Authorization: localStorage.getItem('token') || ''
      }
    };
  },
  created() {
    // 从URL获取sku参数
    const urlParams = new URLSearchParams(window.location.search);
    this.sku = urlParams.get('sku');
    
    if (!this.sku) {
      this.$message.error('未指定产品SKU');
      window.close();
      return;
    }
    
    // 加载产品数据
    this.fetchProductDetail();
  },
  methods: {
    /**
     * 获取产品详情
     */
    async fetchProductDetail() {
      this.loading = true;
      try {
        const response = await this.axios.get('/data-serv/product/detail', {
          params: { sku: this.sku }
        });
        
        if (response.data.code === 0 && response.data.data) {
          this.product = response.data.data;
          
          // 填充表单数据
          this.formData.qualityLevel = this.product.qualityLevel || null;
          this.formData.matchLevel = this.product.matchLevel || null;
          this.formData.merits = this.product.merits || '';
          this.formData.imageUrl = this.product.picUrl || '';
          this.formData.videoUrl = this.product.videoUrl || '';
        } else {
          throw new Error(response.data.message || '获取产品详情失败');
        }
      } catch (error) {
        console.error('获取产品详情失败:', error);
        this.$message.error('获取产品详情失败');
        window.close();
      } finally {
        this.loading = false;
      }
    },
    
    /**
     * 图片上传前验证
     */
    beforeImageUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error('图片大小不能超过1MB');
        return false;
      }
      this.imageUploading = true;
      this.imageProgress = 0;
      this.imageProgressColor = '#409EFF';
      return true;
    },
    
    /**
     * 视频上传前验证
     */
    beforeVideoUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('视频大小不能超过10MB');
        return false;
      }
      this.videoUploading = true;
      this.videoProgress = 0;
      this.videoProgressColor = '#409EFF';
      return true;
    },
    
    /**
     * 图片上传进度
     */
    handleImageProgress(event, file, fileList) {
      this.imageProgress = Math.round(event.percent);
    },
    
    /**
     * 视频上传进度
     */
    handleVideoProgress(event, file, fileList) {
      this.videoProgress = Math.round(event.percent);
    },
    
    /**
     * 图片上传成功
     */
    handleImageSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.imageProgressColor = '#67C23A';
        this.formData.imageUrl = response.data;
        this.$message.success('图片上传成功');
      } else {
        this.imageProgressColor = '#F56C6C';
        this.$message.error(response.message || '图片上传失败');
      }
      setTimeout(() => {
        this.imageUploading = false;
      }, 1000);
    },
    
    /**
     * 视频上传成功
     */
    handleVideoSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.videoProgressColor = '#67C23A';
        this.formData.videoUrl = response.data;
        this.$message.success('视频上传成功');
      } else {
        this.videoProgressColor = '#F56C6C';
        this.$message.error(response.message || '视频上传失败');
      }
      setTimeout(() => {
        this.videoUploading = false;
      }, 1000);
    },
    
    /**
     * 图片上传失败
     */
    handleImageError(err, file, fileList) {
      console.error('图片上传失败:', err);
      this.imageProgressColor = '#F56C6C';
      this.$message.error('图片上传失败');
      setTimeout(() => {
        this.imageUploading = false;
      }, 1000);
    },
    
    /**
     * 视频上传失败
     */
    handleVideoError(err, file, fileList) {
      console.error('视频上传失败:', err);
      this.videoProgressColor = '#F56C6C';
      this.$message.error('视频上传失败');
      setTimeout(() => {
        this.videoUploading = false;
      }, 1000);
    },
    
    /**
     * 处理保存
     */
    async handleSave() {
      // 验证必填字段
      if (!this.formData.qualityLevel || !this.formData.matchLevel) {
        this.$message.error('请填写所有必填字段');
        return;
      }
      
      this.saving = true;
      
      try {
        const saveData = {
          sku: this.sku,
          qualityLevel: this.formData.qualityLevel,
          matchLevel: this.formData.matchLevel,
          merits: this.formData.merits,
          imageUrl: this.formData.imageUrl,
          videoUrl: this.formData.videoUrl
        };
        
        const response = await this.axios.post('/data-serv/product/modify', saveData);
        
        if (response.data.code === 0) {
          this.$message.success('保存成功');
          window.close();
        } else {
          throw new Error(response.data.message || '保存失败');
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error(error.message || '保存失败');
      } finally {
        this.saving = false;
      }
    },
    
    /**
     * 处理取消
     */
    handleCancel() {
      window.close();
    }
  }
}
</script>

<style scoped>
.product-detail-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
  padding-bottom: 40px;
}

.page-title {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  text-align: left;
}

.section {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background-color: #fff;
}

.section-title {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: left;
}

.info-row {
  display: flex;
  margin-bottom: 15px;
}

.info-label {
  width: 150px;
  font-weight: 600;
  color: #606266;
  text-align: left;
}

.info-value {
  flex: 1;
  color: #303133;
  text-align: left;
}

.uneditable {
  color: #909399;
  font-style: italic;
  text-align: left;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 10px;
  font-weight: 500;
  color: #606266;
  text-align: left;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.upload-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.upload-col {
  display: flex;
  align-items: center;
  gap: 10px;
}

.upload-label {
  font-weight: 500;
  color: #606266;
  white-space: nowrap;
  text-align: left;
}

.upload-button {
  display: inline-block;
}

.progress-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.progress-col {
  flex: 1;
  min-width: 300px;
}

.progress-container {
  margin-top: 10px;
}

.preview-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.preview-col {
  flex: 1;
  min-width: 300px;
}

.preview-card {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 16px;
  height: 100%;
  background-color: #fff;
}

.preview-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #495057;
  text-align: left;
}

.preview-content {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.no-preview {
  color: #909399;
  font-style: italic;
}

.preview-img {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
}

.preview-video {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .product-detail-container {
    padding: 15px;
  }
  
  .info-row {
    flex-direction: column;
    gap: 10px;
  }
  
  .info-label {
    width: 100%;
  }
  
  .upload-row {
    flex-direction: column;
    gap: 15px;
  }
  
  .upload-col {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .progress-col {
    min-width: 100%;
  }
  
  .preview-col {
    min-width: 100%;
  }
  
  .radio-group {
    flex-direction: column;
    gap: 10px;
  }
}
</style>